import { render, staticRenderFns } from "./choose-your-phones.vue?vue&type=template&id=6db6d808&scoped=true&"
import script from "./choose-your-phones.vue?vue&type=script&lang=js&"
export * from "./choose-your-phones.vue?vue&type=script&lang=js&"
import style0 from "./choose-your-phones.vue?vue&type=style&index=0&id=6db6d808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6d808",
  null
  
)

export default component.exports